/**
 * below function is to set layoutMaster key which will be use to load layout.
 * if no layoutId is set in local store or if it doesnt match with current layout type we update it and reload.
 * if it matches we dont do anything.
 */
export const fetchLayoutType = (currentLayout) => {
    let layoutId = localStorage.getItem("LayoutMaster");
    if (currentLayout && currentLayout.layoutTypeName) {
        if (!layoutId || layoutId === "null" || currentLayout.layoutTypeName !== layoutId) {
            localStorage.setItem("LayoutMaster", currentLayout.layoutTypeName);
            if(window.FirebasePlugin){
                window.FirebasePlugin.setCrashlyticsCustomKey('LayoutMaster', currentLayout.layoutTypeName);
              }
            document.location.reload();
            console.log("we are in  fetchLayoutType match", currentLayout.layoutTypeName)
        }
    }
}